/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Bachelormaster1Inputs */

const en__field_bachelormaster1 = /** @type {(inputs: _Field_Bachelormaster1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bachelor/Master`)
};

const de__field_bachelormaster1 = /** @type {(inputs: _Field_Bachelormaster1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bachelor/Master`)
};

/**
* | output |
* | --- |
* | "Bachelor/Master" |
*
* @param {_Field_Bachelormaster1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_bachelormaster1 = /** @type {((inputs?: _Field_Bachelormaster1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Bachelormaster1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_bachelormaster1(inputs)
	return de__field_bachelormaster1(inputs)
});
export { _field_bachelormaster1 as "_field_bachelorMaster" }